module.exports = __webpack_public_path__ + "img/google.1b943d72.png";